import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const IPLabelRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.ipLabelList,
    children: [
      { index: true, lazy: () => import('./ip-label-list') },
      { path: ':id', lazy: () => import('./ip-label-detail') },
      { path: 'new', lazy: () => import('./ip-label-new') },
    ],
  },
];
